import { Link, useLocation } from "react-router";
import { useSEO } from "@/hooks/useSEO";

export default function NotFound() {
  useSEO({ title: "Page Not Found | Listaa", noIndex: true });
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-[#0a0a12] text-zinc-100 flex items-center justify-center px-6">
      <div className="w-full max-w-lg rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm text-center">
        <p className="text-6xl font-bold text-fuchsia-500 mb-4">404</p>
        <h1 className="text-2xl font-semibold tracking-tight mb-3">Page not found</h1>
        <p className="text-sm text-zinc-400 mb-2">
          The page <span className="text-zinc-200 font-mono">{pathname}</span> doesn't exist or has been moved.
        </p>
        <p className="text-sm text-zinc-500 mb-8">
          If you followed a link that seems broken, you can let us know via our{" "}
          <Link to="/contact" className="text-fuchsia-400 hover:underline">contact page</Link>.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-fuchsia-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-fuchsia-500 transition-colors"
          >
            Go to Home
          </Link>
          <Link
            to="/venues"
            className="rounded-md border border-white/20 px-5 py-2.5 text-sm font-medium text-zinc-200 hover:bg-white/10 transition-colors"
          >
            Browse Venues
          </Link>
          <Link
            to="/contact"
            className="rounded-md border border-white/20 px-5 py-2.5 text-sm font-medium text-zinc-200 hover:bg-white/10 transition-colors"
          >
            Report broken link
          </Link>
        </div>
      </div>
    </div>
  );
}
